<script>
export default {
  name: "proposals-entry",
  props: {
    proposal: Object
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    classOpen() {
      return this.isOpen ? "open" : "";
    }
  }
};
</script>

<template>
  <div class="sbox-lvl-1 hentry proposal" :class="classOpen">
    <div class="main sbox-pad">
      <div class="wrapper">
        <div class="sfield sfield--avatar">
          <img :src="proposal.author.avatar" />
        </div>
        <div class="sfield sfield--author">
          <router-link
            :to="'/profile/' + proposal.author.profile"
            class="sfield__content"
            title="Visit profile"
            >{{ proposal.author.name }}</router-link
          >
        </div>
        <time
          class="sfield sfield--date dt-published"
          :datetime="proposal.date"
        >
          <span class="sfield__content">{{ proposal.date }}</span>
        </time>
        <div class="sfield sfield--rate">
          <span class="sfield__label">Rate</span>
          <span class="sfield__content">{{ proposal.rate }}%</span>
        </div>
        <div class="sfield sfield--amount" :class="proposal.amountIs">
          <span class="sfield__label">Amount</span>
          <span class="sfield__content"
            >${{ proposal.amount | formatMoney }}</span
          >
        </div>
        <div class="sfield sfield--term" :class="proposal.termIs">
          <span class="sfield__label">Term</span>
          <span class="sfield__content">
            {{ proposal.term }}
            <span v-if="proposal.term > 1">months</span>
            <span v-else>month</span>
          </span>
        </div>
        <div class="sfield sfield--mode">
          <span class="sfield__label">Interest Mode</span>
          <span class="sfield__content">{{ proposal.mode }}</span>
        </div>
        <div class="sfield sfield--type">
          <span class="sfield__label">Interest Type</span>
          <span class="sfield__content">{{ proposal.type }}</span>
        </div>
      </div>
    </div>
    <div class="extra sbox-pad">
      <div class="sfield payments">
        <span class="sfield__label">Payments:</span>
        <span class="sfield__content"
          >${{ proposal.payments | formatMoney }}</span
        >
      </div>
      <div class="sfield total_interest">
        <span class="sfield__label">Total Interest:</span>
        <span class="sfield__content"
          >${{ proposal.total_interest | formatMoney }}</span
        >
      </div>
      <div class="sfield total_payment">
        <span class="sfield__label">Total Payment:</span>
        <span class="sfield__content"
          >${{ proposal.total_payment | formatMoney }}</span
        >
      </div>
    </div>
    <div class="expander" @click="isOpen = !isOpen">
      <span v-if="isOpen">Show less</span>
      <span v-else>Show more</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.proposal {
  position: relative;
  overflow: hidden;
}

.proposal .main .wrapper {
  position: relative;
  padding: 1rem 0;
  padding: 0.5rem 0;
  line-height: 1.2;
  display: grid;
  grid-template-columns: 2.5rem 1fr 6rem;
  grid-template-areas:
    "avatar author rate"
    "avatar date rate"
    ". . ."
    ". amount mode"
    ". term type";
  font-size: 0.875rem;
  font-size: 0.75rem;
}

.proposal:not(:last-child) {
  margin-bottom: 0.75rem;
}

.proposal .sfield--avatar {
  grid-area: avatar;
}
.proposal .sfield--author {
  grid-area: author;
}
.proposal .sfield--date {
  grid-area: date;
}
.proposal .sfield--rate {
  grid-area: rate;
  text-align: right;
}
.proposal .sfield--amount {
  grid-area: amount;
}
.proposal .sfield--term {
  grid-area: term;
}
.proposal .sfield--mode {
  grid-area: mode;
}
.proposal .sfield--type {
  grid-area: type;
}

.proposal .sfield--mode,
.proposal .sfield--type {
  text-align: right;
}

.proposal .sfield--avatar img {
  display: block;
  height: 2rem;
  border-radius: 1rem;
}

.proposal .sfield--rate .sfield__label,
.proposal .sfield--amount .sfield__label,
.proposal .sfield--term .sfield__label,
.proposal .sfield--mode .sfield__label,
.proposal .sfield--type .sfield__label {
  display: none;
}

.proposal .sfield--author .sfield__content {
  font-weight: 500;
  font-size: 1rem;
  font-size: 0.875rem;
  color: #1d2140;
}

.proposal .sfield--date .sfield__content {
  font-weight: 400;
  font-size: 0.75rem;
  font-size: 0.6875rem;
  color: #707070;
  color: #6b89b5;
}

.proposal .sfield--rate .sfield__content {
  font-weight: 800;
  /*font-weight:300;*/
  font-size: 1.5rem;
  font-size: 1.375rem;
  /*font-size: 1.25rem;*/
  color: #5616ed;
  color: #5061ef;
  color: #061387;
}

.proposal .sfield--amount .sfield__content,
.proposal .sfield--term .sfield__content {
  font-weight: 500;
  position: relative;
}

.proposal .sfield--amount .sfield__content:before,
.proposal .sfield--term .sfield__content:before {
  content: "";
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  background-color: #5616ed;
  background-color: #5061ef;
  margin-right: 0.5rem;
}

.proposal .sfield--amount.less .sfield__content:before,
.proposal .sfield--term.less .sfield__content:before {
  background-color: rgb(255, 115, 0);
}

.proposal .sfield--amount.more .sfield__content:before,
.proposal .sfield--term.more .sfield__content:before {
  background-color: green;
}

.proposal .sfield--mode .sfield__content,
.proposal .sfield--type .sfield__content {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #6b89b5;
}

.proposal .extra {
  border-top: 1px solid #dfe6f4;
  background-color: #f6f9ff;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
}
.proposal:not(.open) .extra {
  display: none;
}
.proposal .extra .sfield {
  /* width: 33.333333333%; */
  display: flex;
  justify-content: space-between;
  /* flex-direction: row; */
}
.proposal .extra .sfield__label {
  font-weight: 500;
  font-size: 0.875em;
  color: #a2afcd;
}
.proposal .extra .sfield__content {
  font-weight: 600;
  color: #061387;
  /*color: #2d3766;*/
}
.proposal .expander {
  border-top: 1px solid #dfe6f4;
  background-color: #f6f9ff;
  /*position: absolute;*/
  /*bottom: 0;*/
  /*left: 0;*/
  width: 100%;
  text-align: center;
  font-size: 0.875em;
  padding: 0.5rem;
  cursor: pointer;
  /*display: none;*/
}
@media (max-width: 31.9375em), (min-width: 40em) and (max-width: 49.9375em) {
  .proposal .sfield--date {
    padding-bottom: 0.5rem;
  }
}
@media (min-width: 32em) and (max-width: 39.9375em), (min-width: 50em) {
  .proposal .main .wrapper {
    align-items: center;
    grid-template-columns: 2.5rem 33% 1fr 12% minmax(4.375rem, 22%);
    grid-template-columns: 2.5rem 34% 23% 16% minmax(3.75rem, 22%);
    grid-template-areas:
      "avatar author amount mode rate"
      "avatar date term type rate";
  }
}
</style>
